// extracted by mini-css-extract-plugin
export default {"ad-button":"AdButton_ad-button__umnev","ad-button-icon":"AdButton_ad-button-icon__HGPAY","ad-button-text":"AdButton_ad-button-text__OIugL"};